import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { media } from '../../../../styles/Qtheme';
import { DeskTopCalVW, MobileCalVW } from '../../../../utils/CalVW';
import { View } from '@/styles/reactnative.tsx';

export const Container = styled.header<{
  $isHome: boolean;
  $isDarkMode: boolean;
}>`
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 999;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${({ $isHome, $isDarkMode, theme }) => {
    if ($isHome) {
      return $isDarkMode ? 'rgba(8, 13, 12, 0.2)' : 'rgba(229, 232, 246, 0.2)';
    }
    return theme.body;
  }};

  @media ${media.desktop} {
    padding: 10px 18px;
    top: 0;
    left: 0;
  }

  @media ${media.mobile} {
    padding: 0 18px 0 0;
    height: 50px !important;
  }
`;

export const HeaderWrapper = styled(View)`
  width: 100%;
  height: 91px;
  padding: 0 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;

  @media ${media.desktop2} {
    padding: 0 ${DeskTopCalVW(60)} !important;
  }

  @media ${media.mobile} {
    padding: 0 ${MobileCalVW(20)} !important;
    height: 50px !important;
  }
`;

export const LogoContainer = styled.h1`
  min-width: 110px;
  width: 110px;

  img {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 1700px) {
    min-width: 100px;
    margin-right: 10px;
  }

  @media ${media.desktop} {
    min-width: 120px;
    width: 120px;
  }

  @media ${media.mobile} {
    width: ${MobileCalVW(70)};
  }
`;

export const MenuBox = styled.ul`
  display: flex;
  align-items: center;
  gap: 36px;

  //@media (max-width: 1700px) {
  //    gap: 45px;
  //}

  @media ${media.desktop} {
    display: none;
  }
`;

export const Menu = styled(Link)`
  font-size: 19px;
  font-weight: 400;
  color: ${({ theme }) => theme.text};
  display: flex;
  align-items: center;
  gap: 6px;

  @media (max-width: 1700px) {
    font-size: 16px;
  }
`;

export const RightBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${media.desktop} {
    display: none;
  }
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const subMenuBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1440px) {
    display: none;
  }
`;

export const GraButton = styled(Link)`
  width: 107px;
  height: 30px;
  background: linear-gradient(to right, #4facfe, #d83aeb);
  border-radius: 50px;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginButton = styled(Link)`
  width: 80px;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.71px;
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.COLORS.ButtonBorder};
  background-color: ${({ theme }) => theme.COLORS.ButtonBg};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
    color: white;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SearchInput = styled.div`
  width: 173px;
  height: 30px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.searchBg};
  outline: none;
  border: none;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.text};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 12px;

  input {
    width: 100%;
    flex: 1;
    border: none;
    background-color: transparent;
    outline: none;
  }

  span {
    margin-top: -2px;
  }

  @media (max-width: 1440px) {
    display: none;
  }
`;
